export default __webpack_public_path__ + "static/game_category-71b90f5cca28230806230b9c1b6e19d3.webp";